import {
  Component,
  ChangeDetectionStrategy,
  input,
  booleanAttribute,
  output,
  signal,
  viewChild,
} from '@angular/core';
import {
  SatPopover,
  SatPopoverHorizontalAlign,
  SatPopoverModule,
  SatPopoverVerticalAlign,
} from '@zerops/zef/popover';
import { CommonModule } from '@angular/common';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { ZefCopyToClipboardModule } from '@zerops/zef/copy-to-clipboard';
import { ZuiMaterialFormStackModule } from '@zerops/zui/material-form-stack';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'zui-confirm-pop',
  templateUrl: './confirm-pop.component.html',
  styleUrls: ['./confirm-pop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    ZuiMaterialFormStackModule,
    SatPopoverModule,
    ZefCopyToClipboardModule,
    FormsModule,
  ],
})
export class ConfirmPopComponent {
  confirmButtonText = input<string>();
  confirmButtonIcon = input<string>();
  confirmColor = input('accent');

  closeButtonText = input<string>();

  heading = input<string>();
  subtitle = input<string>();

  verticalAlign = input<SatPopoverVerticalAlign>('below');
  horizontalAlign = input<SatPopoverHorizontalAlign>('center');

  confirmationText = input('DELETE ME');
  enableTextConfirmation = input(false, { transform: booleanAttribute });

  popRef = viewChild(SatPopover);

  confirm = output<void>();
  closeTrigger = output<void>();

  verificationTextInput = signal<string>('');
}
